import { Card, CardHeader, CardDescription, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { formatCurrency, formatQuantidade } from '@/lib/utils/formatters';
import type { TotaisDoTopo, ValorDoQuadro } from './totais-do-topo';

interface TotaisCardsProps {
  totais: TotaisDoTopo;
}

function ConteudoDoQuadro({
  quadro,
  formatar,
  larguraSkeleton,
}: {
  quadro: ValorDoQuadro;
  formatar: (valor: number) => string;
  larguraSkeleton: string;
}) {
  if (quadro.estado === 'carregando') {
    return <Skeleton className={`h-8 ${larguraSkeleton}`} role="status" aria-label="Carregando" />;
  }

  if (quadro.estado === 'erro') {
    return (
      <span className="text-sm font-normal text-muted-foreground">Não foi possível carregar</span>
    );
  }

  return <>{formatar(quadro.valor)}</>;
}

export function TotaisCards({ totais }: TotaisCardsProps) {
  return (
    <div className="grid gap-6 md:grid-cols-4 mb-8">
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Total Entradas</CardDescription>
          <CardTitle className="text-2xl" data-testid="quadro-total-entradas">
            <ConteudoDoQuadro
              quadro={totais.totalEntradas}
              formatar={formatQuantidade}
              larguraSkeleton="w-16"
            />
          </CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Total Saídas</CardDescription>
          <CardTitle className="text-2xl" data-testid="quadro-total-saidas">
            <ConteudoDoQuadro
              quadro={totais.totalSaidas}
              formatar={formatQuantidade}
              larguraSkeleton="w-16"
            />
          </CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Valor Entradas</CardDescription>
          <CardTitle className="text-2xl text-green-600" data-testid="quadro-valor-entradas">
            <ConteudoDoQuadro
              quadro={totais.valorEntradas}
              formatar={formatCurrency}
              larguraSkeleton="w-32"
            />
          </CardTitle>
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Valor Saídas</CardDescription>
          <CardTitle className="text-2xl text-primary" data-testid="quadro-valor-saidas">
            <ConteudoDoQuadro
              quadro={totais.valorSaidas}
              formatar={formatCurrency}
              larguraSkeleton="w-32"
            />
          </CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
}
